import { Absence } from '../../absences/services/AbsenceService';

export interface AvailableEmployee {
  id: number;
  first_name: string;
  last_name: string;
  employee_number?: string;
  is_available?: boolean;
  conflict_reason?: string;
  min_hours?: number;
  photo_url?: string;
}

export interface AssetAssignment {
  shiftId: number;
  jobTitle: string;
  workAreaColor?: string;
}

export interface EmployeeAssignment {
  shiftId: number;
  jobTitle: string;
  workAreaColor?: string;
}

export interface DayInfo {
  dateStr: string;
  label: string;
}

export type TabKey = 'backlog' | 'projekte' | 'mitarbeiter' | 'assets';

export const PROJECT_COLORS: Array<{ bg: string; text: string }> = [
  { bg: '#10b981', text: '#ffffff' },
  { bg: '#7c3aed', text: '#ffffff' },
  { bg: '#021a4a', text: '#ffffff' },
  { bg: '#ec4899', text: '#ffffff' },
  { bg: '#fbbf24', text: '#000000' },
];

export const getProjectColor = (projectId: number) => {
  return PROJECT_COLORS[projectId % PROJECT_COLORS.length];
};

export type { Absence };
